import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Gerund Software Solutions</h3>
            <p>Building innovative software solutions that make a difference.</p>
          </div>
          
          <div className="footer-section">
            <h4>Products</h4>
            <ul>
              <li><a href="/slot-in">Slot In App</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact</h4>
            <p>Get in touch with us for custom software solutions.</p>
            <p>Email: info@gerund.dev</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 Gerund Software Solutions. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 